import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliMask, LiliMaskedInputV2 } from '@lili/lili-frontend-common';
import { OnboardingFormFields } from '@Types/index.ts';
import { ControllerWrapper } from '@Hooks/index';

export const OwnerIdentityForm = () => {
  const { t } = useTranslation();

  return (
    <div className=' w-full'>
      <Heading.H9 fontWeight={FontWeight.SEMIBOLD} className='mb-[16px] text-text-main-secondary'>
        {t('pages.addOwner.identitySection.title')}
      </Heading.H9>
      <ControllerWrapper name={OnboardingFormFields.SSN}>
        {({ onChange, value, onBlur, error }) => {
          return (
            <LiliMaskedInputV2
              onBlur={onBlur}
              value={value}
              errorMessage={error?.message}
              mask={LiliMask.SSN}
              onChange={onChange}
              id={OnboardingFormFields.SSN}
              title={t('pages.identity.ssnFieldTitle')}
            />
          );
        }}
      </ControllerWrapper>
      <ControllerWrapper name={OnboardingFormFields.DATE_OF_BIRTH}>
        {({ onChange, value, onBlur, error }) => {
          return (
            <LiliMaskedInputV2
              onBlur={onBlur}
              value={value}
              errorMessage={error?.message}
              mask={LiliMask.DATE}
              onChange={onChange}
              id={OnboardingFormFields.DATE_OF_BIRTH}
              title={t('pages.identity.bdFieldTitle')}
            />
          );
        }}
      </ControllerWrapper>
    </div>
  );
};
